import { Backdrop as MuiBackdrop, styled } from '@mui/material'

export const Backdrop = styled(MuiBackdrop)({
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
})
